import { all } from 'redux-saga/effects';

import usersRoot from '../modules/users/saga';

function* rootSaga() {
  yield all([usersRoot()]);
}

export default rootSaga;
